import { FormState, Tuple } from '@amzn/wfm-axiom-forms-renderer-stencil/dist/types/model/Forms';
import { ExtensionVisitor, METADATA_RESPONSE_PREFIX } from 'src/components/forms/extensions/ExtensionVisitor';
import { VisitableExtension } from 'src/components/forms/extensions/VisitableExtension';
import { buildMetadataLabelUntyped } from 'src/components/common/MetadataLabel';


/**
 * An ExtensionVisitor that will look for extensions of type target_entity.
 *
 *  When the conditions are met, a target entity string will be generated.
 */
export class TargetEntityVisitor implements ExtensionVisitor<string> {

    static readonly TARGET_ENTITY_TYPE = 'target_entity';
    static readonly TYPE_KEY = 'type';

    private readonly formState: FormState;
    private targetEntityString: string = '';

    constructor(formState: FormState) {
        this.formState = formState;
    }

    visit = (extension: VisitableExtension): string => {
        this.targetEntityString = '';
        if (extension.type === TargetEntityVisitor.TARGET_ENTITY_TYPE && extension.content) {
            extension.content.forEach(
                tuple => this.processContent(extension.id, tuple)
            );
        }
        return this.targetEntityString;
    };

    getResult = () => this.targetEntityString;

    private processContent = (extensionId: string, content: Tuple | null) => {
        if (content) {
            // extract key
            if (content.key === TargetEntityVisitor.TYPE_KEY) {
                const metadataKey = content.value;
                const responseId = METADATA_RESPONSE_PREFIX + extensionId;
                const metadataValue = this.formState.responses[responseId];
                if (metadataValue) {
                    this.targetEntityString = buildMetadataLabelUntyped(metadataKey, metadataValue);
                }
            }
        }
    };
}